import { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router';

import { getUserToken } from '@/shared/services/user-hash';
import MainLoader from '@/shared/ui/main-loader';
import { useAppDispatch } from '@/store';
import { setIsAuthorized } from '@/store/auth.slice';

import useSessionSync from './hooks/useSessionSync';

/**
 * Определяет статус сессии на входе в кабинет: пока токен в куке есть —
 * считаем сотрудника авторизованным, иначе ProtectedRoute уводит его на
 * страницу входа.
 *
 * TODO: тихий refresh по refreshToken, когда на бэке появится ручка обновления
 * пары токенов — сейчас протухший accessToken отлавливается только на 401.
 */
const AuthorizedProvider: React.FC = () => {
  const dispatch = useAppDispatch();
  const [ready, setReady] = useState(false);
  const started = useRef(false);

  useSessionSync();

  useEffect(() => {
    // Защита от двойного запуска (StrictMode dev): bootstrap делаем один раз.
    if (started.current) return;
    started.current = true;

    const { accessToken } = getUserToken();
    dispatch(setIsAuthorized(Boolean(accessToken)));
    setReady(true);
  }, [dispatch]);

  if (!ready) return <MainLoader fullScreen />;

  return <Outlet />;
};

export default AuthorizedProvider;
